import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
    CartesianGrid,

} from "recharts";
import { Card, Col, Row, CardHeader, CardBody, CardFooter, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { usePagination } from "../../hooks/usePagination";
import DateTimePicker from 'react-datepicker'
import { useEffect, useState } from "react";
import { format } from "date-fns";
import ApiService from "../../services/apiService";
import PumpingStation from "../PumpingStation/PumpingStation";
import { toast } from "react-toastify";
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";

type chartProp = {
    fromDateTime?: string | null;
    toDateTime?: string | null;
    generateKey?: number | null | undefined;
    id?: number | string;
    selectedDashboard?: string|null

};

const BarChart2 = ({ fromDateTime, toDateTime, generateKey, id,selectedDashboard }: chartProp) => {

    const [isEnabled, setIsEnabled] = useState<boolean>(false)
    const [powerConsumptionData, setPowerConsumptionData] = useState<any[]>([])
    const [pumpingstation, setPumpingStation] = useState<any[]>()
    const [selectedPumpingStation, setSelectedPumpingStation] = useState<string>('')
    const [dropdownOpen, setDropdownOpen] = useState<boolean>()
    const [autoSlide, setAutoSlide] = useState(true);
    const [startIndex, setStartIndex] = useState(0);
    

    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 6); 
    startDate.setHours(0, 0, 0, 0);


 



    const toggleDropdown = () => setDropdownOpen(prev => !prev)

    const getWindowSize = () => {
        const width = window.innerWidth;
      
        // 13–14 inch laptops (≈ 1280–1440px)
        if (width <= 1440) return 7;
      
        return 10;
      };
      const [windowSize, setWindowSize] = useState<number>(getWindowSize());
      

      useEffect(() => {
        const handleResize = () => {
          setWindowSize(getWindowSize());
          setStartIndex(0); // reset pagination on resize
        };
      
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
      

    const getPowerConsumption = async () => {
        try {
            const response = await ApiService.axiosApi(`/pumpingstation/dailypowerconsumption`, {
                method: 'GET',
                params: {
                   
                    pageNumber: 0,
                    pageSize: 0,
                    fromDate: fromDateTime == null ? format(startDate, 'yyyy-MM-dd HH:mm:ss') : format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'),
                    toDate: toDateTime == null ? format(endDate, 'yyyy-MM-dd HH:mm:ss') : format(toDateTime, 'yyyy-MM-dd HH:mm:ss')
                }
            })
            if (response.success) {
                const updatedData = response.data.data.map((dateTime:any)=>(
                    {
                      
                      dateTime:format(new Date(dateTime.dateTime), "yyyy-MM-dd"),
                      powerConsumption: Number(dateTime.powerConsumption)
                    }
        
                 ))
                setPowerConsumptionData(updatedData)
            } else {
               
                    
                toast.error('Unable to find data at this moment')
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getPowerConsumption();
    }, [generateKey])



    const handleNext = () => {
        if (powerConsumptionData && startIndex + windowSize < powerConsumptionData.length) {
            setStartIndex(startIndex + windowSize);
        }
    };

    const handlePrev = () => {
        if (startIndex - windowSize >= 0) {
            setStartIndex(startIndex - windowSize);
        }
    };
  

    const visibleData = powerConsumptionData?.slice(startIndex, startIndex + windowSize) || [];

    return (

        <Col style={{ height: '100%' }}>


            <Card className="m-0 b-r-0 ">


                <CardHeader>
                    <div className="d-flex justify-content-between align-items-center">



                    <span>
                         <h5 style={{ fontWeight: '600' }}>Power Consumption</h5>
                         <h6 style={{fontSize:'12px'}}> {fromDateTime ? format(new Date(fromDateTime), "dd/MM/yyyy ") : format(startDate,"dd/MM/yyyy ")} -
                         {toDateTime ? format(new Date(toDateTime), "dd/MM/yyyy ") : format(endDate,"dd/MM/yyyy ")}</h6>
                         </span>

                        <div className='d-flex'>
                           
                            <button className="icon-button " onClick={handlePrev} disabled={startIndex === 0}><LeftIcon/></button>
                            
                            <button className="icon-button" onClick={handleNext} disabled={startIndex + windowSize >= powerConsumptionData.length}><RightIcon/></button>
                        </div>

                    </div>


                </CardHeader>

                <CardBody>


                    <ResponsiveContainer width="100%" height={300} >
                        <BarChart
                            data={visibleData}
                            barCategoryGap='0%'
                            barGap='1'

                        >

                            <XAxis dataKey="dateTime" padding={{ left: 5, right: 5 }} 
                            tick={{ fontSize: 15, textAnchor: 'end' }} 
                            tickMargin={1}          
                            interval={0}
                            angle={-20}  
                            height={50}
                            tickFormatter={(value) => {
                              const date = new Date(value);
                              return date.toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                
                              });
                            }}
                            />
                            <YAxis
                             tick={({ x, y, payload }) => (
                                <text
                                  x={x}
                                  y={y}
                                  textAnchor="end"
                                  dominantBaseline="start"
                                  
                                  fill="#666"
                                  fontSize={12}
                                >
                                  {payload.value}
                                </text>
                              )}
                                domain={[0, 'dataMax + 120']} />



                            <Tooltip formatter={(KWH: number, name: string) => [`${KWH}`, name]}
                                cursor={false}
                                contentStyle={{
                                    backgroundColor: "white", // Tooltip box color
                                    borderRadius: "4px",
                                    border: "1px solid #ddd",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                }}

                            />

                            <Bar
                                dataKey="powerConsumption"
                                animationDuration={600}
                                label={{ position: "top",fontSize:'12' }}
                                radius={[0, 0, 0, 0]}
                                barSize={30}
                                fill="#2B5F60"

                            >

                                {powerConsumptionData?.map((entry: any, index) => (
                                    <Cell key={`cell-${index}`} />
                                ))}

                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </CardBody>


            </Card>

        </Col>

    )
}

export default BarChart2